import { render } from "./PDFFormEditorView.vue?vue&type=template&id=b6a038bc&scoped=true"
import script from "./PDFFormEditorView.vue?vue&type=script&lang=js"
export * from "./PDFFormEditorView.vue?vue&type=script&lang=js"

import "./PDFFormEditorView.vue?vue&type=style&index=0&id=b6a038bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a038bc"]])

export default __exports__